module.exports = __webpack_public_path__ + "img/core1.be7a0bab.png";